'use strict';

queryStringHelper.$inject = ["common", "Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.queryStringHelper = queryStringHelper;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function queryStringHelper(common, Enums) {
    return {
        getFilterParam: getFilterParam,
        getCategoryFilters: getCategoryFilters,
        getSellerIds: getSellerIds,
        getDiscountsOnly: getDiscountsOnly,
        getSelectedIdsFromQueryString: getSelectedIdsFromQueryString,
        getDiscountTypes: getDiscountTypes
    };

    // formats the selected filters into a query string parameter
    function getFilterParam(filterCategories, categoryId, selectedId) {
        var param = '';
        angular.forEach(filterCategories, function (filterCategory) {

            // for non-hierarchical lists: add all selected id's
            // for hierarchical lists: add only 1 id (the one at the lowest level)
            // for hierarchical lists: the parent id might be set, this is passed in the selectedId argument
            if (filterCategory.id) if (categoryId && filterCategory.id === categoryId) {
                // set the query string param from the arguments, not from the selected items in filterCategory
                if (selectedId <= 0) {
                    // don't add the category to the query string param
                } else {
                    if (param.length > 0) {
                        param += '__';
                    }

                    param += categoryId;
                    param += '_' + selectedId;
                }
            } else {
                var hasAnySelectedItem = null;

                if (filterCategory.isHierarchical) {
                    hasAnySelectedItem = _lodash2.default.some(filterCategory.items, { isSelected: true });
                    angular.forEach(filterCategory.items, function (item) {
                        if (!hasAnySelectedItem) {
                            hasAnySelectedItem = _lodash2.default.some(item.children, { isSelected: true });
                            angular.forEach(item.children, function (item) {
                                if (!hasAnySelectedItem) {
                                    hasAnySelectedItem = _lodash2.default.some(item.children, { isSelected: true });
                                }
                            });
                        }
                    });
                } else {
                    hasAnySelectedItem = _lodash2.default.some(filterCategory.items, { isSelected: true });
                }

                if (hasAnySelectedItem) {
                    if (param.length > 0) {
                        param += '__';
                    }
                    param += filterCategory.id;

                    // if the category is hierarchical add the selected child id's
                    if (filterCategory.isHierarchical) {
                        angular.forEach(filterCategory.items, function (item) {
                            var hasChildrenSelected = false;
                            // set childcategories in the params
                            angular.forEach(item.children, function (child) {
                                if (child.isSelected) {
                                    param += '_' + child.id;
                                    hasChildrenSelected = true;
                                }
                                angular.forEach(child.children, function (child) {
                                    if (child.isSelected) {
                                        param += '_' + child.id;
                                        hasChildrenSelected = true;
                                    }
                                });
                            });

                            // set the parentcategories in the params
                            if (item.isSelected && !hasChildrenSelected) {
                                param += '_' + item.id;
                            }
                            if (item.isSelected && filterCategory.isSellerCategory && !hasChildrenSelected) {
                                param += '_s';
                            }
                        });
                    } else {
                        angular.forEach(filterCategory.items, function (item) {
                            if (item.isSelected) {
                                param += '_' + item.id;
                                if (filterCategory.isSellerCategory) {
                                    param += '_s';
                                }
                            }
                        });
                    }
                }

                //if the category has children
                // filterCategory.items.forEach((categoryFilter) => {
                //     categoryFilter.children.forEach((child) => {

                //     });
                // });
            }
        });

        return param;
    }

    // parse the query string parameter into an array of category filters, 
    // which can be passed to the product search API call
    function getCategoryFilters(queryStringParam) {
        //TODO: validate
        var categoryFilters = [];

        if (!queryStringParam) {
            return categoryFilters;
        }

        var categories = queryStringParam.split('__');

        angular.forEach(categories, function (categoryString) {
            var values = categoryString.split('_');
            var categoryType = values[0];
            // var isCategoryType = GetIsCategoryType(categoryType);
            // var isSellerCategoryType = GetIsSellerCategoryType(categoryType);
            // isSellerCategoryType
            // if(values[2] && values[2]=== 's'){
            //     isCategoryType = true;
            //     values.pop();
            // }
            // if (!isCategoryType) {
            //     return categoryFilters;
            // }
            var categoryIsSeller = CategoryIsSeller(categoryType);

            if (categoryIsSeller) {
                return categoryFilters;
            }

            var categoryIds = [];
            for (var i = 1; i <= values.length - 1; i++) {
                if (values[i] !== 's') {
                    var id = parseInt(values[i]);
                    categoryIds.push(id);
                }
            }

            var categoryFilter = { CategoryType: categoryType, CategoryIds: categoryIds };
            categoryFilters.push(categoryFilter);
        });

        return categoryFilters;
    }

    function getDiscountTypes(queryStringParam) {
        var discountTypeIds = [];

        if (!queryStringParam) {
            return discountTypeIds;
        }

        var categories = queryStringParam.split('__');

        angular.forEach(categories, function (categoryString) {
            var values = categoryString.split('_');
            var categoryType = values[0];

            if (categoryType === '101') {
                for (var i = 1; i < values.length; i++) {
                    var id = parseInt(values[i]);
                    discountTypeIds.push(id);
                }
            }
        });

        return discountTypeIds;
    }

    function getSellerIds(queryStringParam) {
        var sellerIds = [];

        if (!queryStringParam) {
            return sellerIds;
        }

        var categories = queryStringParam.split('__');

        angular.forEach(categories, function (categoryString) {
            var values = categoryString.split('_');

            var category = values[0];
            //if (category === 'sellers') {
            if (category === String(Enums.otherCategoryType.seller.id)) {
                for (var i = 1; i <= values.length - 1; i++) {
                    var id = parseInt(values[i]);
                    sellerIds.push(id);
                }
            }
        });

        return sellerIds;
    }

    function getDiscountsOnly(queryStringParam) {
        // when filter starts with '102_1' or contains '__102_1', then checkbox only discounts is selected
        var searchValue1 = String(Enums.otherCategoryType.discountsOnly.id) + '_1';
        var searchValue2 = '__' + Enums.otherCategoryType.discountsOnly.id + '_1';
        return queryStringParam && (queryStringParam.indexOf(searchValue1) === 0 || queryStringParam.indexOf(searchValue2) >= 0) ? true : false;
    }

    function getSelectedIdsFromQueryString(queryStringParam, categoryId) {
        if (!queryStringParam) {
            return null;
        }

        var categories = queryStringParam.split('__');

        for (var i = 0; i < categories.length; i++) {
            var categoryString = categories[i];
            var values = categoryString.split('_');
            var categoryType = values[0];

            if (String(categoryType) === String(categoryId)) {
                var selectedIds = [];
                for (var _i = 1; _i <= values.length - 1; _i++) {
                    var id = parseInt(values[_i]);
                    if (typeof id === 'number' && !isNaN(id)) {
                        selectedIds.push(id);
                    }
                }

                return selectedIds;
            }
        }

        return null;
    }

    // function getSelectedIdOnLowestLevel(items) {
    //     var selectedId = 0;

    //     for (let i=0; i<items.length; i++) {
    //         if (items[i].isSelected) {
    //             selectedId = items[i].id;   
    //         }
    //     }

    //     return selectedId;
    // }

    // function GetIsCategoryType(categoryType) {
    //     var categoryTypeId = parseInt(categoryType);
    //     if (!categoryTypeId) { return false; }

    //     return common.enums.existsIdInEnum(Enums.categoryType, categoryTypeId);
    // }

    // function GetIsSellerCategoryType(categoryType) {
    //     // = categoryType endsWith 'S'
    //     return categoryType.indexOf('S', categoryType.length - 1) !== -1;
    // }

    function CategoryIsSeller(categoryType) {
        return common.enums.existsIdInEnum(Enums.otherCategoryType, parseInt(categoryType));
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/queryStringHelper.js
// module id = 825
// module chunks = 0